import React from 'react';

const reasons = [
  {
    title: 'Immediate improvement',
    description: 'Noticeable smoke and soot reduction within the first few firing cycles.',
  },
  {
    title: 'Lower fuel bills',
    description:
      'More complete combustion means less fuel fired for the same process output.',
  },
  {
    title: 'Cleaner emissions',
    description:
      'Helps you move closer to internal ESG goals and tightening environmental norms.',
  },
  {
    title: 'Protects equipment',
    description:
      'Less carbon and sludge on critical components extends life and reduces downtime.',
  },
  {
    title: 'Built for legacy plants',
    description:
      'Micro 24 performs in older boiler rooms and process lines without major upgrades.',
  },
];

const WhyChoose = () => {
  return (
    <section className="section dark" id="why-choose">
      <h2 className="section-title">Why MICRO 24?</h2>
      <div className="cards">
        {reasons.map((item, idx) => (
          <div key={idx} className="card">
            <h3>{item.title}</h3>
            <p>{item.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhyChoose;